import axios from 'axios';

export default {
    fetchAll() {
        return axios.get('/profileUnit/fetchAll/');
    },
};
